export function createAsyncActionTypes(actionType) {
    return {
        request: actionType,
        success: `${actionType}_SUCCESS`,
        failure: `${actionType}_FAILURE`,
        reset: `${actionType}_RESET`,
    };
}
